import DetailPurchaseOrder from './DetailPurchaseOrder'

export default DetailPurchaseOrder